import useMainLayout from './useMainLayout';
import useDefaultLayout from './useDefaultLayout';

export default {
  useMainLayout,
  useDefaultLayout,
};
